import Icon from '../Icon';
import React from 'react';
import { useDispatch } from 'react-redux';
import { setMobileMenuOpen } from '../../Actions/Navigation.action';

const NavigationMobileTrigger = () => {
  const dispatch = useDispatch();

  return (
    <button
      onClick={() => dispatch(setMobileMenuOpen(true))}
      className="flex items-center justify-center rounded-full bg-headerIconBg p-3"
    >
      <Icon name="menu" className="text-headerIcon" />
    </button>
  );
};

export default NavigationMobileTrigger;
